// extracted by mini-css-extract-plugin
export default {"alert":"Alert_alert__m7RI7"};